// Components
import Overlay from "@scripts/components/overlay";

class OneTimeAuthorizationGenerateTokenPage {
    constructor(el) {
        this.el = el;
        this.init();
    }

    init() {
        this.initOverlay();
    }

    initOverlay() {
        this.formOverlay = new Overlay({ target: this.el });

        const form = document.querySelector(".js-send-otac-form");
        if (form) {
            form.addEventListener("submit", (e) => {
                this.formOverlay.show();
            });
        }
    }
}

// Startup
document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById("js-one-time-authorization-generate-token");
    if (el) new OneTimeAuthorizationGenerateTokenPage(el);
});